export default {"src":"/_next/static/media/review-trash.875c0f7c.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};